module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('BuyoutTabs'), _vm._v(" "), _c('AlphabetScroll', {
    attrs: {
      "alphabet": _vm.alphabet,
      "context": this,
      "scrollPos": _vm.scrollPos
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "offer-scroll"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "letter-block",
      attrs: {
        "id": ("letter-" + (letter.letter))
      }
    }, _vm._l((_vm.rows[letter.letter]), function(row) {
      return (_vm.Helper.getOfferTitle(_vm.offers, row.id)) ? _c('StatisticTable', {
        key: row.id,
        attrs: {
          "title": ((_vm.Helper.getOfferTitle(_vm.offers, row.id)) + " " + (_vm.Storage.developMode ? ("(" + (row.id) + ")") : '')),
          "headColumns": _vm.headColumns,
          "footColumns": _vm.footColumns[row.id],
          "rows": row.cells
        }
      }) : _vm._e()
    }))
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e81af7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/buyout/Offer.vue
// module id = 546
// module chunks = 0